// Axios
import Axios from "./axios";

export const fetchDownloaders = () => {
  return new Promise((resolve, reject) => {
    const data = Axios.get(`/download/downloaders`);
    resolve(data);
  });
};
